/**
 * @desc 通过店铺和订单ID获取系统单信息,orderId代表客户订单号
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(
  params: API.walmart.systemOrderFacadeImpl.getSystemOrderMqDto.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/walmart/systemOrder/getSystemOrderMqDto`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
